import "core-js/modules/es.function.name.js";
import React, { useContext } from 'react';
import FontAwesome from 'react-fontawesome';
import PropTypes from 'prop-types';
import { Box } from '@applyboard/ui-components';
import { SelectedTemplate } from "../styles";
import { UnderlinedButton } from "../../style/CommonStyles";
import { useInitialProps } from "../../../hooks/useInitialProps";
import { useEventTracker, UserContext } from '@applyboard/ui-utils';
import { getApplicationStatusMessage } from "../../../util/common";
var NoteTemplateButton = function NoteTemplateButton(_ref) {
  var _application$meta;
  var note = _ref.note,
    onClearTemplate = _ref.onClearTemplate,
    onCreateFromTemplate = _ref.onCreateFromTemplate;
  var _useInitialProps = useInitialProps(),
    application = _useInitialProps.application;
  var currentUser = useContext(UserContext);
  var _useEventTracker = useEventTracker({
      data: {
        applicationId: application === null || application === void 0 ? void 0 : application.id,
        applicationStatus: getApplicationStatusMessage(application),
        applicationStage: (application === null || application === void 0 ? void 0 : (_application$meta = application.meta) === null || _application$meta === void 0 ? void 0 : _application$meta.current_stage.name) || (application === null || application === void 0 ? void 0 : application.current_stage.name) || (application === null || application === void 0 ? void 0 : application.current_stage),
        role: currentUser === null || currentUser === void 0 ? void 0 : currentUser.role
      }
    }),
    trackEvent = _useEventTracker.trackEvent;
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    mb: 1,
    ml: 1.25
  }, /*#__PURE__*/React.createElement(UnderlinedButton, {
    onClick: function onClick() {
      return onCreateFromTemplate(trackEvent);
    }
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "clipboard"
  }), "Create From Template"), note && note.template && note.template.id != null && /*#__PURE__*/React.createElement(SelectedTemplate, null, /*#__PURE__*/React.createElement("span", null, "\u2002|\u2002", note.template.title, " (", note.template.id, ")", ' '), /*#__PURE__*/React.createElement(FontAwesome, {
    onClick: onClearTemplate,
    name: "times"
  })));
};
NoteTemplateButton.propTypes = {
  note: PropTypes.object.isRequired,
  onClearTemplate: PropTypes.func,
  onCreateFromTemplate: PropTypes.func
};
export default NoteTemplateButton;